module.exports = __webpack_public_path__ + "static/img/a052.3357895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a052.jpg
// module id = hBdT
// module chunks = 0